module.exports = __webpack_public_path__ + "img/18.f15c1fda.jpg";